import React, { useState, useEffect } from 'react';
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import { Grid } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import Layout from 'components/Layout/Layout';
import { DataRangeFilter } from 'components/DataRangeFilter/DataRangeFilter';
import { SITES } from 'queries/site';
import DrawerNative from '../../../components/DrawerNative';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { UpdatePage } from './edit';
import { AddPage } from './create';
import DeleteProducts from './delete';
import { GET_PAGES } from '../../../queries/page';

export default function SitePages() {
  const [sitesFilter, setSitesFilter] = useState<string[]>([]);
  const [pages, setPages] = useState([]);
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
  const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
  const [falconSites, setFalconSites] = useState([]);

  const { data: falconSitesData } = useQuery(SITES, {
    variables: {
      hosted: 'Falcon',
    },
  });

  useEffect(() => {
    if (falconSitesData) {
      const fetchedFalconSites = falconSitesData.sites.map(
        (site: any) => site.domain,
      );
      setFalconSites(fetchedFalconSites);
    }
  }, [falconSitesData]);

  const queryPages = useQuery(GET_PAGES, {
    fetchPolicy: 'network-only',
    variables: {
      siteDomains: sitesFilter,
    },
  });
  const { loading, error, refetch } = queryPages;
  const refetchPages = refetch;

  useEffect(() => {
    if (queryPages.data) {
      const { data } = queryPages;
      setPages(data.listPages);
    }
  }, [queryPages]);

  const toolbar = (selectedRows: {
    data: Array<{ index: number; dataIndex: number }>;
  }) => (
    <Grid
      container
      spacing={0}
      item
      xs={9}
      alignItems="flex-start"
      justify="flex-end"
      direction="row"
    >
      <Grid item xs={1}>
        <DeleteProducts
          selectedRows={selectedRows}
          pages={pages}
          refetchList={refetchPages}
        />
      </Grid>
    </Grid>
  );

  const options: MUIDataTableOptions = {
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    responsive: 'standard',
    customToolbarSelect: toolbar,
  };

  const ActionsRow = (tableMeta: any) => {
    const title = tableMeta.rowData[0];
    const id = tableMeta.rowData[1];
    const siteDomain = tableMeta.rowData[2];
    const content = tableMeta.rowData[4];
    const template = tableMeta.rowData[5];

    const dataToUpdate = {
      title,
      id,
      siteDomain,
      content,
      template,
    };

    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerNative
            open={isUpdateDrawerOpen}
            title="Edit Page"
            labelButtonAction={title}
            width="100%"
          >
            <UpdatePage
              data={dataToUpdate}
              setIsDrawerOpen={setIsUpdateDrawerOpen}
              refetch={refetchPages}
            />
          </DrawerNative>
        </Grid>
        <Grid item xs={6} />
      </Grid>
    );
  };

  const permissions = {
    showSitesFilter: true,
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={2}>
          <PageTitle title="Site Pages" />
          <br />
          <DrawerNative
            open={isAddDrawerOpen}
            title="Page"
            labelButtonAction="Add"
            width="100%"
          >
            <AddPage
              setIsDrawerOpen={setIsAddDrawerOpen}
              refetch={refetchPages}
            />
          </DrawerNative>
        </Grid>
        <Grid xs={5} item />
        <Grid item xs={5}>
          <DataRangeFilter
            filterSite={sitesFilter}
            setFilterSite={setSitesFilter}
            sites={falconSites}
            permissions={permissions}
            customColumnSize={12}
          />
        </Grid>
      </Grid>
      {loading ? (
        <MUITableLoading
          columns={['TITLE', 'SITE DOMAIN', 'SLUG', 'TEMPLATE']}
        />
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MUIDataTable
              title={false}
              data={pages}
              columns={[
                {
                  name: 'title',
                  label: 'TITLE',
                  options: {
                    customBodyRender: (value, tableMeta) => {
                      return ActionsRow(tableMeta);
                    },
                    empty: true,
                    filter: true,
                    sort: true,
                  },
                },
                {
                  name: 'id',
                  label: 'ID',
                  options: {
                    display: false,
                  },
                },
                {
                  name: 'siteDomain',
                  label: 'SITE DOMAIN',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'slug',
                  label: 'SLUG',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'content',
                  label: 'CONTENT',
                  options: {
                    display: false,
                  },
                },
                {
                  name: 'template',
                  label: 'TEMPLATE',
                  options: {
                    display: true,
                  },
                },
              ]}
              options={options}
            />
          </Grid>
        </Grid>
      )}
    </Layout>
  );
}
